<h1 class="center">
    Paramètres utilisateur
</h1>
<nav>
    <a routerLinkActive="active-link" routerLink="./list">Liste</a>
    <a routerLinkActive="active-link" routerLink="./create">Création</a>
</nav>
<router-outlet></router-outlet>